import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'splitBy'
})
/**
 * Split string to array by a specified separator string
 */
export class SplitByPipe implements PipeTransform {
    transform(value: string, separator: string): string[] {
        return value.split(separator);
    }
}
